import { memo, useCallback } from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const HotelListHeader = memo(() => {
  const navigate = useNavigate();

  const handleAddNewHotel = useCallback(() => {
    navigate("/hotels/new");
  }, [navigate]);

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-white dark:bg-[#111c44] p-6 rounded-2xl shadow-sm border border-slate-200 dark:border-white/10">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-800 dark:text-slate-100">
          Hotel Management
        </h1>
        <p className="text-sm font-medium text-slate-500 dark:text-slate-400 mt-1">
          Manage and monitor all properties on the platform.
        </p>
      </div>
      <button
        onClick={handleAddNewHotel}
        className="h-10 px-5 bg-blue-600 dark:bg-blue-500 hover:bg-blue-700 dark:hover:bg-blue-600 text-white rounded-xl text-sm font-bold transition-all flex items-center justify-center gap-2 shadow-sm w-full md:w-auto mt-2 md:mt-0"
      >
        <Plus size={18} />
        Add New Hotel
      </button>
    </div>
  );
});
